<template>
  <v-app id="app">
    <Frontpage  v-if="!$store.state.auth.userdata.accesstoken">></Frontpage>
    <Dashboard  v-if="$store.state.auth.userdata.accesstoken">></Dashboard>
  </v-app>
</template>

<script>
import Dashboard from '@/components/Dashboard.vue'
import Frontpage from '@/components/Frontpage.vue'

export default {
  name: 'App',
  components: {
    Frontpage,
    Dashboard
  },
  created () {
    this.$store.dispatch('tryAutoLogin')
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue